module.exports = __webpack_public_path__ + "static/media/hands-helping.4bd5a6fc.svg";